import React from "react";
import { Doughnut, Chart } from "react-chartjs-2";
import { doughnutOptions } from "./_commonSharedChartOptions";
import _ from "lodash";
import { setColor } from "../../../../views/Dashboard/dashboard/ColorPalette";
import { connect } from "react-redux";
import { WidgetNoDataToDisplay, WidgetServerError } from "../../../../components/DashboardWidget/WidgetCommon";
import { uniqueUsersHeader } from "./_detailsTableHeaders";
import { uniqueUsersDataPreview } from "./_previewData";
import { PluginDoughnatLabelInside } from "./_pluginsSource";

const widgetMain = {
  Chart: "NUMBER_OF_UNIQUE_USERS_BY_PLATFORM",
  startDate: "05/18/2019%2012:00%20AM",
  endDate: "06/17/2019%2011:59%20PM",
  skillId: "amzn1.ask.skill.37a093eb-f18b-400a-bb88-388f1cc600d5"
};

const widgetDetails = {
  Chart: "NUMBER_OF_UNIQUE_USERS_IN_TOTAL_DETAILED_VIEW",
  startDate: "05/18/2019%2012:00%20AM",
  endDate: "06/17/2019%2011:59%20PM",
  skillId: "amzn1.ask.skill.37a093eb-f18b-400a-bb88-388f1cc600d5"
};

class UniqueUsersContentClass extends React.Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    Chart.pluginService.register(PluginDoughnatLabelInside);
  }

  render() {
    const { widgetData, draggable } = this.props;
    return (
      <div>
        <div className="widgetTitle">Unique Users</div>
        <div className="widgetBody">
          {draggable ? (
            <WidgetServerError draggable={draggable} />
          ) : widgetData === undefined || draggable ? (
            <WidgetNoDataToDisplay draggable={draggable} />
          ) : (
            <Doughnut
              id={widgetMain.Chart}
              data={{
                labels: widgetData.labels,
                datasets: [
                  {
                    data: widgetData.data,
                    backgroundColor: setColor(widgetData.labels)
                  }
                ]
              }}
              options={_.merge({}, doughnutOptions, {
                hover: {
                  onHover: function(e) {
                    let point = this.getElementAtEvent(e);
                    if (point.length) e.target.style.cursor = "pointer";
                    else e.target.style.cursor = "default";
                  }
                },
                showAllTooltips: true
              })}
            />
          )}
        </div>
      </div>
    );
  }
}

export class UniqueUsersPreview extends React.Component {
  componentWillMount() {
    Chart.pluginService.register(PluginDoughnatLabelInside);
  }
  render() {
    return (
      <div>
        <div className="widgetTitle">Unique Users</div>
        <div className="widgetBody">
          <Doughnut
            id={widgetMain.Chart}
            data={uniqueUsersDataPreview}
            options={_.merge({}, doughnutOptions, {
              legend: {
                labels: {
                  boxWidth: 5,
                  fontSize: 8,
                  padding: 2.5
                }
              },
              plugins: {
                datalabels: {
                  font: {
                    size: 7
                  }
                }
              }
            })}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    widgetData: state.dashboard.data["UniqueUsersPerPlatform"]
  };
}

export const UniqueUsersContent = connect(
  mapStateToProps,
  undefined
)(UniqueUsersContentClass);
